import { render, staticRenderFns } from "./Partscounter.vue?vue&type=template&id=5f39223e"
import script from "./Partscounter.vue?vue&type=script&lang=js"
export * from "./Partscounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports